<p class="helppoint-title">{{data.title}}</p>
<div class="deliverylines-edit">
    <div class="baractions">
        <actions [actionstrip]="actions" (clickAction)="onClickAction($event)"></actions>
    </div>
    <div class="deliverylines-row" *ngFor="let l of lines | sortBy:'order'">
        <shared-delivery-line class="line compact" [line]="l" [columns]="columns" [allColumns]="allColumns"
            [readonly]="false" [expanded]="isExpanded(l)" [showDelete]="showDeleteButton(l)"
            (valueChanged)="onLineValueChanged()" (expandToggled)="onExpandedLine(l)"
            (deleteRequested)="onDeleteLine(l)" (addBatch)="onAddBatch(l)"
            (deleteBatch)="onDeleteBatch(l, $event)" (batchChanged)="onBatchValueChanged()">
        </shared-delivery-line>
    </div>
    <!--
        Al CMR els totals sempre s'editen directament (no hi ha suma en viu ni
        "Fijar", veure el comentari a resetTotalsState()). Tot plegat (línies +
        totals) es desa junt en prémer "Acceptar", igual que amb les línies.
    -->
    <div class="totals-title">{{'SHIPMENTDELIVERY.TOTALS.TITLE' | translate}}</div>
    <div class="totals-detail">
        <div class="totals-detail-item" *ngFor="let field of totalFields">
            <input-component [placeholder]="getTotalCaption(field) | translate" [ngModel]="getFixedValue(field)"
                name="totalvalue-{{field}}" type="number" class="fixvalue" autocomplete="off"
                (valueChanged)="onFixedValueChanged(field, $event)"></input-component>
        </div>
    </div>
</div>
<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirmDialog()"
        color="primary">{{'MAINTENANCE.ACCEPT' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()"
        color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>
